import { ethers } from "ethers";

export const formatAmount = (amount: number | string): number => {
  const amt: string = amount?.toString();
  return Number(ethers?.utils?.formatUnits(amt, 6));
};
